<div class="row head-top mx-0 my-3">
    <div class="col-md-5">
        <h5 class="primary-text font-weight-bold sm-18 mt-3">Who are you requesting money from?</h5>
        <form #requestForm="ngForm">
            <div class="form-group box-shadows">
                <input type="text" name="name" ngModel required class="input_field p-3 w-100" placeholder="Name" required>
            </div>
            <div class="form-group box-shadows">
                <input type="email" style="width: 100%!important;" name="email" ngModel required class="input_field p-3 w-100" placeholder="Their email address" required>
            </div>
            <label class="sm-10 secondary-text mb-0" for="">You Request</label>
            <div class="form-group reqMoney">
                <div class="row">
                    <div class="bg-light col-7 col-md-9">
                        <input name="amount" ngModel required class="input_field p-3 w-100 sm-18" placeholder="0.00"  type="number">
                    </div>
                    <div class="col-5 col-md-3">
                        <div class="sm-16 primary-text text-center pt-3">CAD<span class="px-2"><img width="17px" alt="CAD" src="assets/images/cad.svg"></span></div>
                    </div>
                </div>
            </div>
            <small class="sm-12 grey-text">When sending money, we have to ask the reason for your transfer.<br></small>
            <small class="sm-12 grey-text">Please select yours from below.</small>
            <div class="form-group mt-3">
                <select name="purpose" ngModel required class="form-control reqMoney reason bg-light border-0 box-shadows" style="background-color: #ffff!important; font-size: 16px!important;">
                    <option value="" selected> Select Purpose </option>
                    <option [value]="reason.attributes.code" *ngFor="let reason of requestMoneyervice.reasons"> {{reason.attributes.reason}}</option>
                </select>
            </div>
            <div class="form-group box-shadows mt-3">
                <input name="description" ngModel required type="text" class="input_field p-3 w-100" placeholder="Description" required>
            </div>
            <div class="div d-flex  my-3 address_field">
                <button (click)="goBack()"  type="button" class="btn transparent-btn primary-text back-btn">Cancel</button>
                <button [disabled]="!requestForm.valid" (click)="goNext()" class="btn btn-primary  w-100">Next</button>
            </div>
        </form>
    </div>
</div>